export default __webpack_public_path__ + "static/media/logo-compete-2020.f9e748df.png";